module.exports = __webpack_public_path__ + "static/media/texture (30).f5342a6a.jpg";